export default function Flow() {
  const steps = [
    {
      number: '01',
      title: 'ご相談・ヒアリング',
      description: '検討中の企画や、解決したい集客課題について伺います（未定でも可）。',
    },
    {
      number: '02',
      title: 'プランニング・お見積り',
      description: 'ターゲットに合わせた発信戦略、菊田あや子の稼働範囲などを提案。',
    },
    {
      number: '03',
      title: 'ご契約・詳細調整',
      description: '役割分担（集客・広報支援）を明確にし、正式な業務委託を締結。',
    },
    {
      number: '04',
      title: 'プロモーション開始',
      description: '募集開始前からSNSやコミュニティを通じて、ツアーの「期待感」を醸成。',
    },
    {
      number: '05',
      title: 'ツアー実施・資産化撮影',
      description: '同行および撮影。実施後は、次回の集客に活用できる映像素材を納品。',
    },
  ];

  return (
    <section className="py-16 sm:py-24 lg:py-32 px-4 sm:px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-block mb-4 sm:mb-6">
            <span className="border-2 border-[#1e3a8a] text-[#1e3a8a] text-xs font-semibold px-4 sm:px-6 py-2 rounded-full uppercase tracking-wider whitespace-nowrap">
              Flow
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1e3a8a] mb-4 sm:mb-6 leading-tight px-4">
            提携までの5ステップ
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-gray-700 max-w-4xl mx-auto leading-relaxed px-4">
            旅行会社様の業務フローに配慮した、スムーズな導入プロセスをご用意しています。
          </p>
        </div>

        <div className="space-y-6 sm:space-y-8">
          {steps.map((step, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-white to-gray-50 rounded-2xl sm:rounded-3xl shadow-lg hover:shadow-xl transition-all duration-300 p-6 sm:p-8 lg:p-10 border border-gray-100"
            >
              <div className="flex flex-col sm:flex-row items-start gap-4 sm:gap-6">
                <div className="flex items-center gap-3 sm:gap-4 w-full">
                  <div className="flex-shrink-0 w-14 h-14 sm:w-16 sm:h-16 bg-gradient-to-br from-[#1e3a8a] to-[#3b82f6] rounded-2xl flex items-center justify-center shadow-lg">
                    <span className="text-white text-xl sm:text-2xl font-bold">{step.number}</span>
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-[#1e3a8a] mb-3 sm:mb-4 break-words">
                      {step.title}
                    </h3>
                    <p className="text-sm sm:text-base lg:text-[20px] text-gray-700 leading-relaxed lg:leading-[1.8]">
                      {step.description}
                    </p>
                  </div>
                </div>
              </div>
              {index < steps.length - 1 && (
                <div className="flex justify-center mt-6 sm:mt-8">
                  <div className="w-0.5 h-8 sm:h-10 bg-gradient-to-b from-[#1e3a8a] to-transparent"></div>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 sm:mt-16 text-center">
          <p className="text-sm sm:text-base lg:text-[20px] text-gray-600 mb-6 sm:mb-8 px-4 lg:leading-[1.8]">
            各ステップで丁寧にサポートいたします。まずはお気軽にご相談ください。
          </p>
          <a
            href="#contact"
            className="inline-block bg-gradient-to-r from-[#1e3a8a] to-[#3b82f6] text-white px-8 sm:px-10 py-3 sm:py-4 rounded-full text-base sm:text-lg font-bold hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            お問い合わせはこちら
          </a>
        </div>
      </div>
    </section>
  );
}